import { CreateFileInput } from "../../../Shared/dto/create-file-input";
import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreateProfileInput } from "../models/CreateProfileInput";

export class ProfileService {
  static async create(createProfileInput: CreateProfileInput) {
    return await HttpService.request({
      url: "/profile/create",
      method: "POST",
      data: createProfileInput,
    });
  }

  static async createFromFile(createFromFileInput: CreateFileInput) {
    return await HttpService.request({
      url: "/profile/create/from-file",
      method: "POST",
      data: createFromFileInput,
    });
  }

  static async getById(id: string) {
    return await HttpService.request({
      url: `/profile/${id}`,
      method: "GET",
    });
  }

  static async update(id: string, updateProfileInput: CreateProfileInput) {
    return await HttpService.request({
      url: `/profile/${id}`,
      method: "PUT",
      data: updateProfileInput,
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/profile/${id}`,
      method: "DELETE",
    });
  }

  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/profile/${JSON.stringify(ids)}`,
      method: "DELETE",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/profile/find?${queryParams}`,
      method: "GET",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/profile?findOptions=${query}`,
      method: "GET",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/profile/search?query=${encodeURIComponent(query)}`,
      method: "GET",
    });
  }
}
